import Reactotron from 'reactotron-react-js'
import tronsauce from 'reactotron-apisauce'

Reactotron
  .configure() // we can use plugins here -- more on this later
  .use(tronsauce()) // <-- here we go!!!
  .connect() // let's connect!
